import { Path, Svg } from 'react-native-svg';
import React from 'react';
const DraggableItem = (props) => (<Svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <Path d="M13.3334 6H2.66675V7.33333H13.3334V6ZM2.66675 10H13.3334V8.66667H2.66675V10Z" fill={props.fill ?? '#9D99B0'}/>
  </Svg>);
export default DraggableItem;
